import { render, staticRenderFns } from "./ShareManagementinteraction.vue?vue&type=template&id=1ac73256&scoped=true"
import script from "./ShareManagementinteraction.vue?vue&type=script&lang=js"
export * from "./ShareManagementinteraction.vue?vue&type=script&lang=js"
import style0 from "./ShareManagementinteraction.vue?vue&type=style&index=0&id=1ac73256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac73256",
  null
  
)

export default component.exports